import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { RepresentanteModalidadeComercialBadgeModule } from '../components/modalidade-comercial/badge';
import { RepresentanteListComponent } from './representante-list.component';

@NgModule({
    imports: [
        SharedModule,
        RepresentanteModalidadeComercialBadgeModule
    ],
    declarations: [
        RepresentanteListComponent
    ],
    exports: [
        RepresentanteListComponent
    ]
})
export class RepresentanteListModule { }

